<template>
  <div class="item-header">
    <span>{{UserTitle}}</span>
    <el-button size="small" @click="HandleAdd">添加</el-button>
  </div>
</template>

<script>
  export default {
    name: "UserAdd",
    props:{
      UserTitle:{},
      UserAddUrl:{}
    },
    methods:{
      HandleAdd(){
        this.$router.push(this.UserAddUrl)
      }
    }
  }
</script>

<style lang="less" scoped>
  .item-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    span{
      height: 16px;
      font-size: 16px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
    }
  }
</style>